import { render } from "./HowItWorks.vue?vue&type=template&id=43cebc18&ts=true"
import script from "./HowItWorks.vue?vue&type=script&lang=ts"
export * from "./HowItWorks.vue?vue&type=script&lang=ts"

import "./HowItWorks.vue?vue&type=style&index=0&id=43cebc18&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__